import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setNewStage } from "../../actions/dialogRoute.action";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import { ICallAPIFunction, IMessageOptions } from "../../yoello-lib/modules/API2/types";
import { isObjectEmpty } from "../../yoello-lib/modules/utils/objectCheck";
import { IMultiDialogChildren } from "./MultiDialogRoute";
import { useDialogRouteStages } from "./useDialogRouteStages";

/**Handles dialog setup 
 * If no form data will retrieve form data from provided call api
 * if no dialog stage has been setup then will attempt to set that up
 * also an extension of useDialogRouteStages
 * @param props takes the props of the component
 * @param callAPI takes the callAPI of the dialog data type
 * @param formDataKey the key for form data defaukt to "formData"
 */
export function useDialogSetup<T, P extends IMultiDialogChildren>(props: P, callAPI: ICallAPIFunction<T>, formDataKey: string = "formData", messageOptions?: IMessageOptions, ignoreFormCheck?: boolean) {

    const modalProps = useDialogRouteStages(props.history);
    const { stages, getProps, setProps } = modalProps;
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState(getProps(props.dialogKey, formDataKey));
    const dispatch = useDispatch();

    useEffect(() => {
        /**If no form data available then try and get it  */
        if (!props.isNewItem && (ignoreFormCheck || isObjectEmpty(formData))) {
            setIsLoading(true);
            callAPI(HTTPMethods.GET, {
                query: props?.id,
                ...messageOptions,
            }).then(({ isSuccessful, data }) => {
                if (isSuccessful) {
                    setFormData(data);
                    setIsLoading(false);
                    setProps(props.dialogKey, formDataKey, data);
                    return;
                }
                props.onClose();
            })
        }
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        const stage = stages[props.dialogKey];
        if (!stage && formData) {
            dispatch(setNewStage(props.dialogKey, {
                ComponentProps: {
                    //@ts-ignore
                    [formDataKey]: formData ?? props[formDataKey] ?? undefined
                }
            }, props.history.location.pathname, null));

        }
        //eslint-disable-next-line
    }, [props.dialogKey, formData]);

    return {
        isLoading,
        formData,
        setFormData,
        setIsLoading,
        ...modalProps,
    }
}